export enum HOME_FEED_SORTS {
  NEWEST = "FEED_TIME,DESC;USER_ID,DESC;SET_ID,DESC",
  CLOSEST = "VIRTUAL_DISTANCE;IS_ONLINE,DESC;POST_RANK;FEED_TIME,DESC;USER_ID,DESC;SET_ID,DESC",
}

export const HOME_FEED_PAGE_SIZE = 20;
export const HOME_FEED_CARD_WIDTH = 300;
export const TRAILER_START_DELAY = 300;
